export default __webpack_public_path__ + "static/media/Time-empty-state-icon.483ea678.svg";